import { render, staticRenderFns } from "./produtoForm.vue?vue&type=template&id=3b67a590&scoped=true&"
import script from "./produtoForm.vue?vue&type=script&lang=js&"
export * from "./produtoForm.vue?vue&type=script&lang=js&"
import style0 from "./produtoForm.vue?vue&type=style&index=0&id=3b67a590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b67a590",
  null
  
)

export default component.exports